module.exports = __webpack_public_path__ + "img/bugger_01.87bb2cdf.png";